/**
 * Top tab strip — Analytics / Memory / Pull Requests / Settings.
 * Matches the Greptile screenshot exactly. The active tab is derived
 * from the current pathname; `/repositories` keeps the **Settings** tab
 * active (the canonical landing page per the dashboard plan).
 *
 * Memory / Pull Requests / Analytics tabs are functional links but the
 * placeholder pages render a "coming soon" empty state. The active
 * highlight falls through to Settings when the URL doesn't match any
 * tab.
 */
import { NavLink } from 'react-router-dom';

const TABS: Array<{ to: string; label: string }> = [
  { to: '/analytics', label: 'Analytics' },
  { to: '/memory', label: 'Memory' },
  { to: '/pulls', label: 'Pull Requests' },
  { to: '/settings', label: 'Settings' },
];

export function TopTabs() {
  return (
    <nav className="feluda-top-tabs" aria-label="Section">
      {TABS.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end={tab.to === '/settings'}
          className={({ isActive }) =>
            `feluda-top-tab${isActive ? ' feluda-top-tab-active' : ''}`
          }
        >
          {tab.label}
        </NavLink>
      ))}
    </nav>
  );
}